import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import DashboardActionGrid from "./DashboardActionGrid";
import TermsOfUseDialog from "./TermsOfUseDialog";
import { DASHBOARD_SHELL_VARIANTS } from "./dashboardShellConfig";

/**
 * Shared dashboard shell: title, action grid (or custom children), and TOC dialog.
 */
export default function DashboardShellBase({
  title,
  links,
  sectionTitle,
  variant = "pg",
  children,
}) {
  const config = DASHBOARD_SHELL_VARIANTS[variant] || DASHBOARD_SHELL_VARIANTS.pg;

  return (
    <Box
      p={config.shellPadding}
      gap={3}
      display="flex"
      flexDirection="column"
      alignItems="center"
      sx={{ width: "100%", maxWidth: "100%" }}
    >
      <Typography
        variant="h6"
        fontFamily="sans-serif"
        fontWeight={config.titleFontWeight}
        mb={2}
        sx={{
          color: "black",
          ...(config.responsiveTitle
            ? {
                fontSize: { xs: "1.1rem", sm: "1.25rem" },
                textAlign: "center",
              }
            : {}),
        }}
      >
        {title}
      </Typography>

      {children ?? (
        <DashboardActionGrid
          links={links}
          sectionTitle={sectionTitle}
          title={title}
          variant={config.gridVariant || variant}
          groupTitleFontWeight={config.groupTitleFontWeight}
        />
      )}

      <TermsOfUseDialog />
    </Box>
  );
}

DashboardShellBase.propTypes = {
  title: PropTypes.string,
  links: PropTypes.array,
  sectionTitle: PropTypes.string,
  variant: PropTypes.oneOf(["pg", "internal", "lawFirm", "legacy"]),
  children: PropTypes.node,
};
